/**
 * Проверка ответа «О приложении» на границе (D-056).
 *
 * Ответ `GET /api/gateway/v1/about`: `{ generatedAt, release, services: [{ id, name, kind, state, versionReported, version,
 * commit, release, builtAt, startedAt, message, checkedAt }] }`. Недоступная служба — строка `state: 'down'` с причиной
 * словами шлюза; версии и дат у неё нет (`null`).
 */
import { fail, list, optionalFilledText, record, text } from '../../../shared/decode'
import type { AboutReport, AboutService, AboutState } from '../model/types'

const STATES: readonly AboutState[] = ['ok', 'lagging', 'down', 'not-configured']

function stateOf(value: unknown, field: string): AboutState {
  const found = STATES.find((state) => state === value)
  return found ?? fail(`поле ${field} — неизвестное состояние`)
}

function decodeService(entry: unknown, where: string): AboutService {
  const item = record(entry, where)
  if (typeof item.versionReported !== 'boolean') fail(`${where}.versionReported — не логическое`)
  return {
    id: text(item.id, `${where}.id`),
    name: text(item.name, `${where}.name`),
    kind: text(item.kind, `${where}.kind`),
    state: stateOf(item.state, `${where}.state`),
    versionReported: item.versionReported,
    version: optionalFilledText(item.version, `${where}.version`),
    commit: optionalFilledText(item.commit, `${where}.commit`),
    release: optionalFilledText(item.release, `${where}.release`),
    builtAt: optionalFilledText(item.builtAt, `${where}.builtAt`),
    startedAt: optionalFilledText(item.startedAt, `${where}.startedAt`),
    message: optionalFilledText(item.message, `${where}.message`),
    checkedAt: text(item.checkedAt, `${where}.checkedAt`),
  }
}

export function decodeAbout(raw: unknown): AboutReport {
  const body = record(raw, 'о приложении')
  return {
    generatedAt: text(body.generatedAt, 'generatedAt'),
    release: optionalFilledText(body.release, 'release'),
    services: list(body.services, 'services', decodeService),
  }
}
